export const WS_MESSAGE_TYPE = {
  connected: 'connected',
  ping: 'ping',
  pong: 'pong',
  countUpdate: 'count_update',
  newNotification: 'new_notification',
  notification: 'notification',
  message: 'message',
  smsReceived: 'sms_received',
  smsStatus: 'sms_status',
  bulkProgress: 'bulk_progress',
  // The dialer's live-state event. The backend docs call it
  // `power_dialer.updated`, but the socket service delivers dotted event names
  // snake-cased (confirmed on the wire 2026-07-02) — same as `bulk_job.progress`
  // arriving as `bulk_progress`. Both spellings stay subscribed in case a
  // future socket-service change ships the documented name.
  powerDialerUpdated: 'power_dialer.updated',
  powerDialerUpdatedSnake: 'power_dialer_updated',
  // Live-calls roster event ({action: start|end, call}) — documented as
  // `call.live`, delivered snake-cased (see the power-dialer note above).
  callLive: 'call.live',
  callLiveSnake: 'call_live',
  callReceived: 'call_received',
  callRinging: 'call_ringing',
  callAnswered: 'call_answered',
  callMissed: 'call_missed',
  shipmentLeadCreated: 'shipment_lead_created',
  shipmentQuoteCreated: 'shipment_quote_created',
  shipmentOrderCreated: 'shipment_order_created',
  shipmentLeadConverted: 'shipment_lead_converted',
  shipmentLeadAttached: 'shipment_lead_attached',
  shipmentUpdated: 'shipment_updated',
  shipmentOrderCanceled: 'shipment_order_canceled',
  shipmentContractSigned: 'shipment_contract_signed',
  carrierRequestCreated: 'carrier_request_created',
  sdWebhookEvent: 'sd_webhook_event',
  shipmentDispatched: 'shipment_dispatched',
  shipmentDirectDispatched: 'shipment_direct_dispatched',
  shipmentDispatchCancelled: 'shipment_dispatch_cancelled',
  shipmentPosted: 'shipment_posted',
  shipmentUnposted: 'shipment_unposted',
  shipmentPickedUp: 'shipment_picked_up',
  shipmentDelivered: 'shipment_delivered',
  // New-frontend-deploy push ({build_id}) — documented as `version.updated`,
  // expected snake-cased on the wire (see the power-dialer note above).
  versionUpdated: 'version.updated',
  versionUpdatedSnake: 'version_updated',
  // Something moved on a campaign; the only correct response is to drop the
  // campaign queries and refetch. Mirrors the product's constant.
  campaignUpdated: 'campaign_updated',
  subscribeConversation: 'subscribe_conversation',
  unsubscribeConversation: 'unsubscribe_conversation',
  subscribed: 'subscribed',
  unsubscribed: 'unsubscribed',
} as const

export type WsMessageType =
  (typeof WS_MESSAGE_TYPE)[keyof typeof WS_MESSAGE_TYPE]

export const WS_STATUS = {
  idle: 'idle',
  connecting: 'connecting',
  open: 'open',
  closed: 'closed',
} as const

export type WsStatus = (typeof WS_STATUS)[keyof typeof WS_STATUS]

export const WS_PATH = '/socket/ws/connect/'
export const WS_TOKEN_QUERY_KEY = 'token'

export const WS_RECONNECT_MIN_MS = 1_000
export const WS_RECONNECT_MAX_MS = 10_000
export const WS_CONNECTION_TIMEOUT_MS = 10_000

export const WS_HTTP_PROTOCOL = 'http:'
export const WS_HTTPS_PROTOCOL = 'https:'
export const WS_INSECURE_PROTOCOL = 'ws:'
export const WS_SECURE_PROTOCOL = 'wss:'
